import {
    HORSE_RACE_UPDATE_SUBSCRIBE_ERROR,
    HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR,
    HORSE_RACE_UPDATE_RECEIVE_ERROR,
    HORSE_RACE_UPDATE_CONNECT_ERROR,
    HORSE_RACE_UPDATE_FALLBACK_TO_POLLING
} from '../actions/raceUpdate';
import GoogleAnalytics from '../../../utils/GoogleAnalytics';
import config from 'config';

const ERROR_EVENT_CATEGORY = 'Errors';

const errorActions = [
    HORSE_RACE_UPDATE_SUBSCRIBE_ERROR,
    HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR,
    HORSE_RACE_UPDATE_RECEIVE_ERROR,
    HORSE_RACE_UPDATE_CONNECT_ERROR,
    HORSE_RACE_UPDATE_FALLBACK_TO_POLLING    
];

const errorTracker = store => next => action => {
    if (errorActions.includes(action.type)) {
        const {google} = config.metricsVendors;
        const googleAnalytics = new GoogleAnalytics(google.setup);
        const event = {
            eventCategory: ERROR_EVENT_CATEGORY,
            eventAction: action.type
        };

        if (action.type === HORSE_RACE_UPDATE_CONNECT_ERROR) {
            event.eventValue = action.failedCount;
        }

        googleAnalytics.sendTracking('event', event);
    }

    return next(action);
}

export default errorTracker;


// WEBPACK FOOTER //
// ./modules/HorseRacing/middleware/errorTracking.js